import { Grid } from "@mui/material";
import FormTextField from "components/FormFields/FormTextField";
import React from "react";
const LeadInformationInput = ({ fields }) => {
  return (
    <Grid container spacing={2} className="mt-3">
      <Grid item xs={12} spacing={2}>
        <h2 data-label="lead-information-header">Lead Information</h2>
        {Object.keys(fields.leadInformation).map((key) =>
          key !== "episode" ? (
            <>
              <h3>{key.toUpperCase()} Lead Information</h3>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <FormTextField
                    fullWidth
                    value={fields.leadInformation[key].manufacturer}
                    label="Manufacturer"
                    disabled={true}
                    data-text={`lead-information-${key}-manufacturer-field`}
                  />
                </Grid>
                <Grid item xs={4}>
                  <FormTextField
                    fullWidth
                    value={fields.leadInformation[key].model}
                    label="Model"
                    disabled={true}
                    data-text={`lead-information-${key}-model-field`}
                  />
                </Grid>
                <Grid item xs={4}>
                  <FormTextField
                    fullWidth
                    value={fields.leadInformation[key].serialNumber}
                    label="Serial Number"
                    disabled={true}
                    data-text={`lead-information-${key}-serial-number-field`}
                  />
                </Grid>
                <Grid item xs={3}>
                  <FormTextField
                    fullWidth
                    value={fields.leadInformation[key].polarity}
                    label="Polarity"
                    disabled={true}
                    data-text={`lead-information-${key}-polarity-field`}
                  />
                </Grid>
                <Grid item xs={3}>
                  <FormTextField
                    fullWidth
                    value={fields.leadInformation[key].sensing}
                    label="Sensing"
                    disabled={true}
                    data-text={`lead-information-${key}-sensing-field`}
                  />
                </Grid>
                <Grid item xs={3}>
                  <FormTextField
                    fullWidth
                    value={fields.leadInformation[key].pacingThresholdAmplitude}
                    label="Pacing Threshold Amplitude"
                    disabled={true}
                    data-text={`lead-information-${key}-pacing-threshold-amplitude-field`}
                  />
                </Grid>
                <Grid item xs={3}>
                  <FormTextField
                    fullWidth
                    value={
                      fields.leadInformation[key].pacingThresholdPulseWidth
                    }
                    label="Pacing Threshold Pulse Width"
                    disabled={true}
                    data-text={`lead-information-${key}-pacing-threshold-pulse-width-field`}
                  />
                </Grid>
                <Grid item xs={3}>
                  <FormTextField
                    fullWidth
                    value={fields.leadInformation[key].impedanceValue}
                    label="Impedance"
                    disabled={true}
                    data-text={`lead-information-${key}-impedance-field`}
                  />
                </Grid>
              </Grid>
            </>
          ) : (
            <>
              <h3>Episode Information</h3>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <FormTextField
                    fullWidth
                    value={fields.leadInformation[key].vt}
                    label="VT"
                    disabled={true}
                    data-text="lead-information-episode-vt-field"
                  />
                </Grid>
                <Grid item xs={4}>
                  <FormTextField
                    fullWidth
                    value={fields.leadInformation[key].vf}
                    label="VF"
                    disabled={true}
                    data-text="lead-information-episode-vf-field"
                  />
                </Grid>
                <Grid item xs={4}>
                  <FormTextField
                    fullWidth
                    value={fields.leadInformation[key].af}
                    label="AF"
                    disabled={true}
                    data-text="lead-information-episode-af-field"
                  />
                </Grid>
              </Grid>
            </>
          )
        )}
      </Grid>
    </Grid>
  );
};

export default LeadInformationInput;
